import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Label from '../Label';

const RadioButton = ({
  label, id, name, value, ...rest
}) => (
  <>
    <Field
      type="radio"
      id={id}
      name={name}
      value={value}
      {...rest}
    />
    <Label text={label} htmlFor={id} />
  </>
);

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default RadioButton;
